import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Row,
} from "reactstrap";

import Select from "react-select";
import "../css/TableSelect.css";
import PropTypes from "prop-types";
import TableService from "../../../../../services/OrderingServices/TableService";

const TableSelect = ({
  isOpen,
  toggle = () => {},
  selectedTable,
  setSelectedTable = () => {},
  data,
  sectionData = [],
  setSelectedSection = () => {},
  selectedSection = null,
  loading,
  allTables,
}) => {
  // 🔁 Hooks always first
  const [searchQuery, setSearchQuery] = useState("");
  const [tempSelectedTable, setTempSelectedTable] = useState(null);
  const [filterStatus, setFilterStatus] = useState("all");
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  // const [allTables, setAllTables] = useState([]);
  // const [shouldShowSections, setShowSections] = useState(
  //   localStorage.getItem("showSections")
  // );
  // const showSections = localStorage.getItem("shouldShowSections");
  // console.log("🚀 ~ TableSelect ~ showSections:", showSections);

  const user = JSON.parse(localStorage.getItem("user")) || {};
  const shouldShowSections = user?.shouldShowSections;
  // Fetch all tables if showSections is false
  // useEffect(() => {
  //   const fetchAllTables = async () => {
  //     if (!shouldShowSections) {
  //       try {
  //         const tables = await TableService.getList();
  //         setAllTables(tables);
  //       } catch (error) {
  //         console.error("Error fetching tables:", error);
  //       }
  //     }
  //   };
  //   fetchAllTables();
  // }, [shouldShowSections]);

  // ❌ Early return AFTER all hooks
  if (!isOpen) return null;

  const handleSectionChange = (selectedOption) => {
    setSelectedSection(selectedOption);
    setTempSelectedTable(null);
  };

  const handleSectionCardClick = (section) => {
    handleSectionChange({ value: section.id, label: section.name });
  };

  const getStatusIcon = (status) => {
    switch (status?.toLowerCase()) {
      case "available":
        return <span className="status-check">✓</span>;
      case "occupied":
        return <span className="status-cross">✗</span>;
      case "reserved":
        return <span className="status-reserved">R</span>;
      case "undermaintenance":
        return (
          <span className="status-undermaintenance">
            <i class="bx bx-error-alt fs-5"></i>{" "}
          </span>
        );

      default:
        return null;
    }
  };

  // Modified: Use allTables when shouldShowSections is false
  const filteredTables = shouldShowSections
    ? data?.tables?.filter((table) => {
        const matchesSearch = table.tableName
          .toLowerCase()
          .includes(searchQuery.toLowerCase());
        const status = table.tableStatus?.toLowerCase();
        const matchesFilter =
          filterStatus === "all" ||
          (filterStatus === "occupied" && status === "occupied") ||
          status === filterStatus;
        const matchesSection =
          !selectedSection ||
          table.section?.id === selectedSection?.value ||
          (!table.section && data?.id === selectedSection?.value);
        // Hide tables marked as Unavailable
        return (
          matchesSearch &&
          matchesFilter &&
          matchesSection &&
          status !== "unavailable"
        );
      }) || []
    : allTables?.filter((table) => {
        const matchesSearch = table.tableName
          .toLowerCase()
          .includes(searchQuery.toLowerCase());
        const status = table.tableStatus?.toLowerCase();
        const matchesFilter =
          filterStatus === "all" ||
          (filterStatus === "occupied" && status === "occupied") ||
          status === filterStatus;
        // Hide tables marked as Unavailable
        return matchesSearch && matchesFilter && status !== "unavailable";
      }) || [];

  const handleConfirm = () => {
    if (tempSelectedTable) {
      setSelectedTable(tempSelectedTable);
      toggle();
    }
  };

  const sectionOptions = sectionData.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  let lastTapTime = 0;

  const handleTap = (table) => {
    const now = Date.now();
    const diff = now - lastTapTime;

    if (diff < 300 && tempSelectedTable?.id === table.id) {
      // 👉 second tap within 300ms = double-tap detected
      setSelectedTable(table);
      toggle(); // immediately close offcanvas
    } else {
      // 👉 first tap = select only
      setTempSelectedTable(tempSelectedTable?.id === table.id ? null : table);
    }

    lastTapTime = now;
  };

  return (
    <Offcanvas
      isOpen={isOpen}
      toggle={toggle}
      direction="end"
      backdropClassName="bg-dark bg-opacity-50"
      className="shadow-lg animate__animated animate__slideInRight bg-white rounded-start"
      id="offcanvasRight"
    >
      {/* OffcanvasHeader for mobile */}
      <OffcanvasHeader className="d-block d-sm-none">
        <div className="d-flex justify-content-between align-items-center w-100 rounded-top">
          <button className="btn btn-sm btn-light" onClick={toggle}>
            <i class="bx bx-chevron-left"></i>
          </button>
          <div className="d-flex align-items-center text-center justify-content-center w-100 gap-2">
            <i className="ri-stack-line"></i>
            <h5 className="mb-0">Table Selection</h5>
          </div>
        </div>
      </OffcanvasHeader>
      <div
        className="position-absolute d-none d-sm-block"
        style={{ left: "-40px", top: "10px" }}
      >
        <button className="btn btn-sm btn-light" onClick={toggle}>
          <i className="ri-close-line"></i>
        </button>
      </div>
      {/* Desktop Header */}
      <div className="d-none d-sm-flex justify-content-start align-items-center p-3 shadow-sm rounded-top">
        <i className="ri-stack-line"></i>
        <h5 className="mb-0 ms-2">Table Selection</h5>
      </div>

      <OffcanvasBody className="px-lg-4 px-2 py-3 bg-body-tertiary">
        {/* Filter Controls */}
        <div>
          <Row className="py-2 px-3">
            {/* Show section selector only when shouldShowSections is true */}
            {shouldShowSections && (
              <Col lg={3} md={6} xs={10} className="mb-2">
                <Select
                  options={sectionOptions}
                  value={selectedSection}
                  onChange={handleSectionChange}
                  placeholder="Select section"
                  isClearable
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    control: (base, state) => ({
                      ...base,
                      fontSize: "12px",
                      padding: "1px",
                      borderRadius: "20px",
                      borderColor: state.isFocused
                        ? "#2684FF"
                        : base.borderColor,
                      boxShadow: state.isFocused
                        ? "0 0 0 1px #2684FF"
                        : base.boxShadow,
                      "&:hover": {
                        borderColor: "#2684FF",
                      },
                    }),
                  }}
                />
              </Col>
            )}

            {/* Modified condition: Show search when shouldShowSections is false OR when section is selected */}
            {(!shouldShowSections || selectedSection) && (
              <Col
                md={6}
                xs={12}
                lg={3}
                className="mb-2 d-lg-block d-md-block d-none "
              >
                <div className="position-relative">
                  <i className="ri-search-line position-absolute top-50 start-0 translate-middle-y ms-3 text-muted" />
                  <Input
                    type="text"
                    placeholder="Search for table..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="ps-5 py-2 rounded-pill border shadow-sm w-100"
                    style={{ fontSize: "14px" }}
                  />
                  {searchQuery && (
                    <i
                      className="ri-close-line position-absolute top-50 end-0 translate-middle-y me-3 text-danger cursor-pointer"
                      onClick={() => setSearchQuery("")}
                    />
                  )}
                </div>
              </Col>
            )}

            {/* Filters - Show when shouldShowSections is false OR when section is selected */}
            {(!shouldShowSections || selectedSection) && (
              <Col md={12} lg={6} className="d-lg-block d-md-block d-none">
                <div className="filter-pills">
                  {[
                    "all",
                    "available",
                    "occupied",
                    "reserved",
                    "undermaintenance",
                  ].map((status) => (
                    <button
                      key={status}
                      className={`filter-pill ${status}-pill ${
                        filterStatus === status ? "active" : ""
                      }`}
                      onClick={() => setFilterStatus(status)}
                    >
                      {status === "available" && (
                        <span className="pill-dot available-dot"></span>
                      )}
                      {status === "occupied" && (
                        <span className="pill-dot occupied-dot"></span>
                      )}
                      {status === "reserved" && (
                        <span className="pill-dot reserved-dot"></span>
                      )}

                      {status === "undermaintenance" && (
                        <span className="pill-dot undermaintenance-dot"></span>
                      )}
                      {status
                        .replace("-", " ")
                        .replace(/^\w/, (c) => c.toUpperCase())}
                    </button>
                  ))}
                </div>
              </Col>
            )}

            {/* Mobile Filters Toggle - Show when shouldShowSections is false OR when section is selected */}
            {(!shouldShowSections || selectedSection) && (
              <Col xs={2} className="d-block d-lg-none d-md-none">
                <div className="d-flex align-items-center align-content-center py-1">
                  <button
                    className="btn btn-sm btn-success"
                    onClick={() => setShowMobileFilters(true)}
                  >
                    <i className="ri-filter-line"></i>
                  </button>
                </div>
              </Col>
            )}
          </Row>
        </div>

        {/* Mobile Filter Offcanvas */}
        <Offcanvas
          isOpen={showMobileFilters}
          toggle={() => setShowMobileFilters(false)}
          direction="bottom"
          className="d-block d-lg-none"
          style={{
            height: "230px",
            transition: "transform 0.3s ease",
            borderTopLeftRadius: "1rem",
            borderTopRightRadius: "1rem",
            overflow: "hidden",
          }}
        >
          <OffcanvasHeader toggle={() => setShowMobileFilters(false)}>
            Filters
          </OffcanvasHeader>
          <div className="p-2">
            <div className="mb-4 ">
              <div className="position-relative">
                <i className="ri-search-line position-absolute top-50 start-0 translate-middle-y ms-3 text-muted" />
                <Input
                  type="text"
                  placeholder="Search for table..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="ps-5 py-2 rounded-pill border shadow-sm w-100"
                  style={{ fontSize: "14px" }}
                />
                {searchQuery && (
                  <i
                    className="ri-close-line position-absolute top-50 end-0 translate-middle-y me-3 text-danger cursor-pointer"
                    onClick={() => setSearchQuery("")}
                  />
                )}
              </div>
            </div>
            <div className="filter-pills">
              {[
                "all",
                "available",
                "occupied",
                "reserved",

                "undermaintenance",
              ].map((status) => (
                <button
                  key={status}
                  className={`filter-pill ${status}-pill ${
                    filterStatus === status ? "active" : ""
                  }`}
                  onClick={() => setFilterStatus(status)}
                >
                  {status === "available" && (
                    <span className="pill-dot available-dot"></span>
                  )}
                  {status === "occupied" && (
                    <span className="pill-dot occupied-dot"></span>
                  )}
                  {status === "reserved" && (
                    <span className="pill-dot reserved-dot"></span>
                  )}

                  {status === "undermaintenance" && (
                    <span className="pill-dot undermaintenance-dot"></span>
                  )}
                  {status
                    .replace("-", " ")
                    .replace(/^\w/, (c) => c.toUpperCase())}
                </button>
              ))}
            </div>
          </div>
        </Offcanvas>

        {/* Tables */}
        <div className="table-grid-wrapper">
          <div className="table-grid">
            {loading ? (
              <div className="d-flex justify-content-center align-items-center w-100 my-5">
                <div className="spinner-border text-primary" role="status" />
              </div>
            ) : shouldShowSections && !selectedSection ? (
              // Show sections when shouldShowSections is true and no section is selected
              <Row className="w-100">
                {sectionData.map((item) => {
                  // Determine background color based on sectionStatus
                  let bgClass = "";
                  if (item.sectionStatus === "Available")
                    bgClass = "bg-success";
                  else if (item.sectionStatus === "Occupied")
                    bgClass = "bg-danger";
                  else if (item.sectionStatus === "Reserved")
                    bgClass = "bg-dark";
                  else if (item.sectionStatus === "UnderMaintenance")
                    bgClass = "bg-info";
                  return (
                    <Col key={item.id} md={3} lg={3} xs={6}>
                      <Card
                        onClick={() => handleSectionCardClick(item)}
                        className="shadow-sm border-0 rounded-4 cursor-pointer hover-scale"
                        style={{ transition: "transform 0.3s ease-in-out" }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.transform = "scale(1.05)")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.transform = "scale(1)")
                        }
                      >
                        <CardBody className="text-center d-flex flex-column align-items-center justify-content-center">
                          <div
                            className={`${bgClass} text-white rounded-circle d-flex align-items-center justify-content-center mb-3`}
                            style={{ width: 50, height: 50 }}
                          >
                            <i className="ri-folder-3-line ri-xl"></i>
                          </div>
                          <h6 className="fw-bold text-dark mb-0">
                            {item.name}
                          </h6>
                        </CardBody>
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            ) : filteredTables.length > 0 ? (
              // Show tables when shouldShowSections is false OR when a section is selected
              filteredTables.map((table) => (
                <div
                  key={table.id}
                  onClick={() => handleTap(table)}
                  onDoubleClick={() => {
                    setSelectedTable(table);
                    toggle();
                  }}
                  className={`table-card table-${table.tableStatus?.toLowerCase()} table-capacity-${
                    table.capacity
                  } ${
                    tempSelectedTable?.id === table.id ? "table-selected" : ""
                  }`}
                >
                  <div
                    className={`chair-group chair-top ${
                      table.capacity >= 8 ? "chair-wide" : ""
                    }`}
                  >
                    {[
                      ...Array(
                        table.capacity === 2
                          ? 1
                          : table.capacity >= 12
                          ? 3
                          : table.capacity >= 8
                          ? 2
                          : 1
                      ),
                    ].map((_, i) => (
                      <div key={`top-${i}`} className="chair" />
                    ))}
                  </div>
                  <div
                    className={`chair-group chair-bottom ${
                      table.capacity >= 8 ? "chair-wide" : ""
                    }`}
                  >
                    {[
                      ...Array(
                        table.capacity === 2
                          ? 1
                          : table.capacity >= 12
                          ? 3
                          : table.capacity >= 8
                          ? 2
                          : 1
                      ),
                    ].map((_, i) => (
                      <div key={`bottom-${i}`} className="chair" />
                    ))}
                  </div>
                  {table.capacity > 2 && (
                    <div className="chair-group chair-left">
                      {[...Array(table.capacity >= 12 ? 2 : 1)].map((_, i) => (
                        <div key={`left-${i}`} className="chair" />
                      ))}
                    </div>
                  )}
                  {table.capacity > 2 && (
                    <div className="chair-group chair-right">
                      {[...Array(table.capacity >= 12 ? 2 : 1)].map((_, i) => (
                        <div key={`right-${i}`} className="chair" />
                      ))}
                    </div>
                  )}
                  <div className="table-content">
                    <div className="table-name">{table.tableName}</div>
                    <div className="table-status-info">
                      <div className="status-icon-wrapper">
                        {getStatusIcon(table.tableStatus)}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center my-5">
                <i className="ri-emotion-unhappy-line display-4 text-secondary" />
                <h5 className="fw-semibold text-secondary">
                  No Tables Available
                </h5>
                <p className="text-muted mb-0">
                  Please check back later or refresh to see updated
                  availability.
                </p>
              </div>
            )}
          </div>
        </div>
      </OffcanvasBody>

      <ModalFooter className="p-2" style={{ backgroundColor: "#f9fafb" }}>
        <div className="footer-content d-flex justify-content-between w-100">
          {tempSelectedTable && (
            <span className="d-lg-flex d-none w-100">
              Selected Table: <strong>{tempSelectedTable?.tableName}</strong>
            </span>
          )}
          <div className="text-end w-100">
            <button
              onClick={handleConfirm}
              disabled={!tempSelectedTable}
              className="btn btn-success"
            >
              Continue
            </button>
          </div>
        </div>
      </ModalFooter>
    </Offcanvas>
  );
};

TableSelect.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  selectedTable: PropTypes.object,
  setSelectedTable: PropTypes.func,
  data: PropTypes.shape({
    id: PropTypes.number,
    tables: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        tableName: PropTypes.string,
        capacity: PropTypes.number,
        tableStatus: PropTypes.string,
        section: PropTypes.object,
      })
    ),
  }),
  sectionData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })
  ),
  setSelectedSection: PropTypes.func,
  selectedSection: PropTypes.object,
  loading: PropTypes.bool,
};

export default TableSelect;
